export const campaignSendersDomainRouteParamId = 'domainId' as const
export const campaignSendersDomainRouteQueryCheck = 'check' as const
